import React, { PureComponent } from 'react';

export class ValueTransition extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            changing: false,
            children: props.children,
            value: props.value,
        };
        this.animationEnd = this.animationEnd.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value) return { changing: true };

        if (!props.value && props.children !== state.children) return { changing: true };

        return null;
    }

    animationEnd(e) {
        if (e.animationName === this.props.animationName) {
            this.setState({ changing: false, children: this.props.children, value: this.props.value });
        }
    }

    render() {
        // animationName and children not used but useful to remove this props from passedProps
        // eslint-disable-next-line no-unused-vars
        const { component: Component, classAnimationModifier, className: origClassName, animationName, children, value, ...extraProps } = this.props;
        const className = this.state.changing ? classAnimationModifier : origClassName;
        return (
            <Component className={className} onAnimationEnd={this.animationEnd} {...extraProps}>
                {this.state.children}
            </Component>
        );
    }
}
